export const handleErrors = (error: any, message?: string) => {
    console.log("ERROR CODE:", error?.code);
    console.log("ERROR:", error);
    try {
        if (error.code === "auth/email-already-in-use") {
            return "Ky email është në përdorim nga dikush tjetër. Provoni një email të ndryshëm nga ky."
        } else if (error.code === "auth/invalid-credential") {
            if (message === "password-only") return "Fjalëkalimi i vjetër është gabim. Provoni përsëri.";
            else return "Email ose fjalëkalimi është gabim. Provoni përsëri.";
        } else if (error.code === "auth/requires-recent-login") {
            return "Për shkak se ky veprim është i pakthyeshëm: çkyçuni, kyçuni prapë dhe provoni përsëri fshirjen e llogarisë.";
        } else {
            return "Një gabim ka ndodhur. Provoni përsëri.";
        }
    } catch (error) {
        return "Një gabim ka ndodhur. Provoni përsëri.";
    }
}